import React, { FC } from 'react';
import {
  BreakpointConfig,
  createBreakpoints,
  Picture,
} from '../TemplatesGrid/components/Template/Picture/Picture';
import { useTranslation } from '@wix/wix-i18n-config';
import { TemplateMediaContainer } from '../TemplateMediaContainer/TemplateMediaContainer';
import { Template } from '../../domain/entities/template';
import { useMediaLoading } from '../../hooks/useMediaLoading';
import s from './TemplateImage.scss';

export type TemplateImageProps = {
  isLazyLoad?: boolean;
  className?: string;
  index?: number;
  categorySlug?: string;
  template: Template;
};

const SOURCE_IMAGE_SIZE = { width: 1920, height: 2222 };
export const BREAKPOINTS_CONFIG: BreakpointConfig[] = [
  {
    maxScreenWidth: 375,
    imageWidth: 295,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 833,
    imageWidth: 751,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1366,
    imageWidth: 401,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1440,
    imageWidth: 438.5,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1920,
    imageWidth: 425.33,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 2560,
    imageWidth: 638.66,
    densityList: [1, 2],
  },
];

export const TemplateImage: FC<TemplateImageProps> = ({
  template,
  isLazyLoad,
  className,
  index,
  categorySlug,
}) => {
  const breakpoints = createBreakpoints(BREAKPOINTS_CONFIG, SOURCE_IMAGE_SIZE);
  const { t } = useTranslation();
  const thumbnail = template.assets?.find(
    (asset) => asset.type === 'RESPONSIVE_TALL',
  );

  const { onMediaLoadStart, onMediaLoaded, isMediaLoading } = useMediaLoading();

  return (
    <TemplateMediaContainer
      template={template}
      categorySlug={categorySlug}
      index={index}
      isLoading={isMediaLoading}
    >
      {thumbnail?.absoluteUrl ? (
        <Picture
          isLazyLoad={isLazyLoad}
          imagePath={thumbnail?.absoluteUrl || ''}
          sourceImageSize={SOURCE_IMAGE_SIZE}
          breakpoints={breakpoints}
          alt={t('templates.img.altText', template.title)}
          onLoad={onMediaLoaded}
          onLoadStart={onMediaLoadStart}
          imageClassName={className}
        />
      ) : (
        <div className={s.templateImageFallback} />
      )}
    </TemplateMediaContainer>
  );
};
